/**
 * @module data/epMaterialIndex
 * @summary Part number → display name and category, for the mass balance.
 * @description GENERATED FILE — do not hand-edit; see
 *   `scripts/build-materials.py`, which writes this alongside
 *   {@link module:data/epMaterials}.
 *
 *   This is the slice of the raw-material table that the ENGINE needs, and
 *   it is deliberately tiny: the balance runs on every frame of both views,
 *   and the full table belongs in the materials tab's lazy chunk rather
 *   than in the editor's bundle.
 */

/** What one part is called, and what kind of material it is. */
export interface EpIndexEntry {
  /** The workbook's Description cell — what a line is labelled with. */
  name: string;
  /** The workbook's Category cell, e.g. 'PVC RESIN', 'FILLER'. */
  category: string;
}

/** All 152 part numbers. */
export const EP_INDEX: Readonly<Record<string, EpIndexEntry>> = {
  "RE01001": { name: "POLY VINYL CHLORIDE - PVC 70K", category: "PVC RESIN" },
  "RE01002": { name: "S-PVC RESIN GRADE 67 K", category: "PVC RESIN" },
  "RE01003": { name: "S-PVC RESIN 58 K", category: "PVC RESIN" },
  "FL01001": { name: "CALCIUM CARBONATE FINE / 1JLTR", category: "FILLER" },
  "FL01002": { name: "CALCIUM CARBONATE PRECIPITATED", category: "FILLER" },
  "FL01003": { name: "CALCINED CLAY", category: "FILLER" },
  "FL02001": { name: "CALCIUM CARBONATE SUPER FINE", category: "FILLER" },
  "ST01001": { name: "HEAT STABILIZER - Lead Compound Stabilizer", category: "STABILIZER" },
  "ST01011": { name: "Ca/ Zn Heat STABILIZER High Temperature", category: "STABILIZER" },
  "ST01012": { name: "PB Heat Stabilizer - Akropan 2168 GX", category: "STABILIZER" },
  "ST01013": { name: "PB Heat Stabilizer - SAG-CP 515 (Powder Form)", category: "STABILIZER" },
  "ST01014": { name: "High Temperature Lead Stabilizer", category: "STABILIZER" },
  "ST01015": { name: "Lead-free stabilizer for PVC cable", category: "STABILIZER" },
  "ST02001": { name: "STABILIZER - FLAME RETARDANT", category: "STABILIZER" },
  "ST03001": { name: "STABILIZER BAEROSTAB PV-300", category: "STABILIZER" },
  "ST03002": { name: "ULTRA VIOLET STABILIZER", category: "STABILIZER" },
  "PA01001": { name: "CHLORINATED PARAFIN 52%", category: "PLASTICIZER" },
  "PA01003": { name: "PARAFFIN WAX - Baerolub L-KO", category: "PLASTICIZER" },
  "PA02001": { name: "PLASTICIZER - OIL RESISTANT", category: "PLASTICIZER" },
  "PL01001": { name: "PLASTICIZER - DIDP", category: "PLASTICIZER" },
  "PL01004": { name: "PLASTICIZER - DPHP", category: "PLASTICIZER" },
  "PL01005": { name: "Di Octyl Adipate - DOA", category: "PLASTICIZER" },
  "PL01006": { name: "PLASTICIZER - DOTP (Dioctyl Terephthalate)", category: "PLASTICIZER" },
  "PL02001": { name: "PLASTICIZER - DOP", category: "PLASTICIZER" },
  "PL03001": { name: "PLASTICIZER - TOTM", category: "PLASTICIZER" },
  "MB01001": { name: "PIGMENT - ULTRAMARINE BLUE", category: "PIGMENT" },
  "MB01002": { name: "PIGMENT WHITE - (TITANIUM DIOXIDE)", category: "PIGMENT" },
  "MB01003": { name: "PIGMENT -  YELLOW", category: "PIGMENT" },
  "MB01004": { name: "PIGMENT - RED", category: "PIGMENT" },
  "MB01005": { name: "PIGMENT - BLUE", category: "PIGMENT" },
  "MB01006": { name: "PIGMENT - GREEN", category: "PIGMENT" },
  "MB02002": { name: "CARBON BLACK - PVC", category: "CARBON BLACK" },
  "ST03004": { name: "CALCIUM NAPHTHANATE", category: "ADDITIVE" },
  "EL01001": { name: "PE WAX", category: "ADDITIVE" },
  "PA02002": { name: "CALCIUM STEARATE", category: "ADDITIVE" },
  "PA03001": { name: "STEARIC ACID", category: "ADDITIVE" },
  "RE02001": { name: "LDPE HP2022J/2023 j", category: "LDPE RESIN" },
  "RE02003": { name: "RESIN LDPE HP 2022 NN", category: "LDPE RESIN" },
  "RE02006": { name: "LDPE Resin for MV XLPE", category: "LDPE RESIN" },
  "RE02007": { name: "LDPE Resin 2023 N", category: "LDPE RESIN" },
  "RE02009": { name: "LDPE Resin 2025 N", category: "LDPE RESIN" },
  "RC01002": { name: "PEROXIDE - MV XLPE", category: "PEROXIDE" },
  "ST05004": { name: "IRGANOX 1035", category: "ANTIOXIDANT" },
  "ST05007": { name: "SONGNOX 1035", category: "ANTIOXIDANT" },
  "ST05011": { name: "SN OPS 3026 (Premix DSTDP & 1035)", category: "ANTIOXIDANT" },
  "ST05013": { name: "CHAIN TRANSFER AGENT for polymers containing styrene", category: "ADDITIVE" },
  "RE03001": { name: "LLDPE Resin 318CNJ", category: "LLDPE RESIN" },
  "RE03002": { name: "LLDPE 324 CNJ", category: "LLDPE RESIN" },
  "RE03015": { name: "LLDPE Resin 318BJ", category: "LLDPE RESIN" },
  "SP16120": { name: "SILANE MIXTURE - FG", category: "SILANE" },
  "ST01002": { name: "SABOSTAB UV 119", category: "STABILIZER" },
  "RC01005": { name: "SILICON OIL - 350 CST", category: "ADDITIVE" },
  "RC01006": { name: "SILMIX - TS 519013", category: "SILANE" },
  "RC01008": { name: "SILICON OIL - 100 CST", category: "ADDITIVE" },
  "RC01010": { name: "PURE SILANE", category: "SILANE" },
  "ST05002": { name: "IRGANOX 1010", category: "ANTIOXIDANT" },
  "ST05010": { name: "SONGNOX DSTDP", category: "ANTIOXIDANT" },
  "ST05005": { name: "IRGANOX PS 802", category: "ANTIOXIDANT" },
  "ST05003": { name: "IRGANOX MD 1024", category: "METAL DEACTIVATOR" },
  "FL05004": { name: "Tin Catalyst", category: "DBTDL" },
  "ST05009": { name: "SONGNOX 1024", category: "METAL DEACTIVATOR" },
  "FL03001": { name: "FR FILLER - ATH SUPER FINE PRECIPITATED (107)", category: "ALUMINUM HYDROXIDE" },
  "FL03002": { name: "FR FILLER - ATH FINE PRECIPITATED(104)", category: "ALUMINUM HYDROXIDE" },
  "FL03006": { name: "FR FILLER - MAGNESIUM HYDROXIDE", category: "ALUMINUM HYDROXIDE" },
  "FL03007": { name: "FR FILLER - ATH (APYRAL 60 CD)", category: "ALUMINUM HYDROXIDE" },
  "FL03008": { name: "FR FILLER - ATH (TL01-X10)", category: "ALUMINUM HYDROXIDE" },
  "FL03009": { name: "Aluminium Hydroxide (KMT)", category: "ALUMINUM HYDROXIDE" },
  "FL03010": { name: "ATH FINE PRECIPITATED ETIFINE 704", category: "ALUMINUM HYDROXIDE" },
  "EL01010": { name: "Coupling Agent", category: "COUPLING AGENT" },
  "EL02001": { name: "ELASTOMER -  ENGAGE 8411", category: "IMPACT MODIFIER" },
  "EL02002": { name: "RESIN - EVA 28-03", category: "EVA RESIN" },
  "EL02003": { name: "RESIN - EVA 28-05", category: "EVA RESIN" },
  "EL02004": { name: "RESIN - EVA 28-800", category: "EVA RESIN" },
  "EL02009": { name: "RESIN - EVA 40-55", category: "EVA RESIN" },
  "EL02011": { name: "RESIN - EVA 33-400", category: "EVA RESIN" },
  "EL02013": { name: "COHERE 8570", category: "IMPACT MODIFIER" },
  "MB-PE RED": { name: "PE COLOR MASTER BATCH - RED (CJ10194374BG)", category: "COLOR MB" },
  "MB-RR-EVA": { name: "RODENT REPELLANT MASTERBATCH", category: "MASTERBATCH" },
  "MB-TR-EVA": { name: "TERMITE REPELLANT MASTERBATCH", category: "MASTERBATCH" },
  "RE03007": { name: "LLDPE Resin 320BJ", category: "LLDPE RESIN" },
  "RE02002": { name: "RESIN LLDPE 6821 N", category: "LLDPE RESIN" },
  "RE03009": { name: "RESIN HDPE -BM1052", category: "LLDPE RESIN" },
  "RE03011": { name: "LLDPE 128 CNJX", category: "LLDPE RESIN" },
  "RE03012": { name: "LLDPE 319 BJ", category: "LLDPE RESIN" },
  "RE03013": { name: "RESIN MDPE - P438J", category: "MDPE RESIN" },
  "EL01003": { name: "RESIN - EBA 35-40", category: "EVA RESIN" },
  "EL01004": { name: "RESIN - EBA 17-04", category: "EVA RESIN" },
  "EL01005": { name: "RESIN - EBA 30-02", category: "EVA RESIN" },
  "EL02005": { name: "RESIN - EVA 28-04 (VC-590)", category: "EVA RESIN" },
  "EL02006": { name: "RESIN - EVA 33-25", category: "EVA RESIN" },
  "EL02007": { name: "RESIN - EVA 33-15", category: "EVA RESIN" },
  "EL02008": { name: "RESIN - EVA 28-07", category: "EVA RESIN" },
  "MB-PE BLK": { name: "PE COLOR MASTER BATCH - BLK (Astra 1100)", category: "COLOR MB" },
  "MB02003": { name: "CARBON BLACK - JACKETING", category: "CARBON BLACK" },
  "RE08001": { name: "PP RESIN", category: "PP RESIN" },
  "RE08002": { name: "PP RESIN OFF SPEC (Pellet)", category: "PP RESIN" },
  "RE08005": { name: "PP RAFIA PELLETS - Recycle", category: "PP RESIN" },
  "RE08006": { name: "PP RESIN 519 A", category: "PP RESIN" },
  "RE08007": { name: "PP Resin 5001P", category: "PP RESIN" },
  "EL01011": { name: "PE WAX FOR MB", category: "PE WAX" },
  "MB03077": { name: "CaCO3 FILLER MASTERBATCH - FG", category: "FILLER MB" },
  "MB04008": { name: "PVC MATER BATCH WHITE", category: "COLOR MB" },
  "PE-MB WT": { name: "PE COLOR MASTER BATCH - WHT", category: "COLOR MB" },
  "ST01005": { name: "ZINC STEARATE", category: "ADDITIVE" },
  "ST01007": { name: "FOAMING AGENT", category: "ADDITIVE" },
  "IMC-HDPE-NT": { name: "HDPE M80064", category: "HDPE RESIN" },
  "RE04004": { name: "POLYPROPYLENE MAT. (Y101)", category: "PP RESIN" },
  "MB02004": { name: "CARBON BLACK - SEMICON BOND", category: "CARBON BLACK" },
  "MB02005": { name: "CARBON BLACK - SEMICON STRIP", category: "CARBON BLACK" },
  "MB02007": { name: "Carbon Black - SC Bond - Printex HV", category: "CARBON BLACK" },
  "MB02009": { name: "Carbon Black - SC Strip - XPB 553", category: "CARBON BLACK" },
  "RC01003": { name: "PEROXIDE - SEMICON STRIP", category: "PEROXIDE" },
  "RC01004": { name: "PEROXIDE - SEMICON BOND", category: "PEROXIDE" },
  "BG01001": { name: "PLASTIC BAG - 25 KG", category: "BAGS" },
  "BG01003": { name: "PP JUMBO BAGS - 1250 KG", category: "BAGS" },
  "BG01004": { name: "PP JUMBO BAGS - 1250 KG Non-Printed", category: "BAGS" },
  "BG01005": { name: "PP JUMBO BAGS - 1500 KG Printed", category: "BAGS" },
  "BG02001": { name: "OCTAGONAL JUMBO BOX - PRINTED", category: "BOX" },
  "BG02002": { name: "OCTAGONAL JUMBO BOX- UNPRINTED", category: "BOX" },
  "BG02003": { name: "OCTAGONAL JUMBO BOX - SLEEVES", category: "BOX" },
  "BG02004": { name: "OCTAGONAL JUMBO BOX- USED /  RECYCLED", category: "BOX" },
  "BG02005": { name: "Octagonal Box Sleeve (New)", category: "BOX" },
  "BG03003": { name: "PLASTIC BAG - 25 KG", category: "BAGS" },
  "BG04001": { name: "PAPER CORE  SIZE : 90 X 6 X 500", category: "PAPER CORES" },
  "BG04002": { name: "PAPER CORE  SIZE : 90 X 10 X 580", category: "PAPER CORES" },
  "BG04003": { name: "PAPER CORE  SIZE : 135 X 6 X 550", category: "PAPER CORES" },
  "BG04004": { name: "PAPER CORE  SIZE : 135 X 10 X 550", category: "PAPER CORES" },
  "BG04008": { name: "PAPER CORE  SIZE : 76 X 10 X 1200 MM", category: "PAPER CORES" },
  "BG04009": { name: "PAPER CORE SIZE : 76 X 14 X 1300 MM", category: "PAPER CORES" },
  "BG04010": { name: "PAPER CORE  SIZE : 76 X 10 X 60 MM", category: "PAPER CORES" },
  "BG04011": { name: "PAPER CORE  SIZE : 76 X 10 X 900 MM", category: "PAPER CORES" },
  "BG04012": { name: "PAPER CORE  SIZE : 76 X 10 X 80 MM", category: "PAPER CORES" },
  "BG04013": { name: "PAPER CORE  SIZE : 75 X 10 X 40 MM", category: "PAPER CORES" },
  "BG04014": { name: "PAPER CORE  SIZE : 76 x 9 x 500", category: "PAPER CORES" },
  "BG04016": { name: "PAPER CORE  SIZE : 76 x 10 x 200", category: "PAPER CORES" },
  "BG04017": { name: "PAPER CORE  SIZE : 100 X 10 X 40 MM", category: "PAPER CORES" },
  "BG04018": { name: "PAPER CORE  SIZE : 100 X 10 X 60 MM", category: "PAPER CORES" },
  "BG04019": { name: "PAPER CORE  SIZE : 100 X 10 X 50 MM", category: "PAPER CORES" },
  "BG04020": { name: "PAPER CORE  SIZE : 100 X 10 X 80 MM", category: "PAPER CORES" },
  "BGAL003": { name: "ALUMINIUM BAG - 25 KG W/VALUE", category: "BAGS" },
  "BGAL004": { name: "ALUMINIUM BAG LINER - 600 KG", category: "BAGS" },
  "BGLC02003": { name: "New Lids for Octagonal Boxes", category: "BOX" },
  "BGLC02004": { name: "Cardboard for Bottom Discharge Lids(W822589)", category: "BOX" },
  "BGLC02005": { name: "New Lids for Octagonal Boxes - Bottom Discharge", category: "BOX" },
  "MB-AS-15%": { name: "ANTI-STATIC MASTERBATCH 15%", category: "ADDITIVE" },
  "MB-PIB-60%": { name: "PIB MASTERBATCH 60%", category: "ADDITIVE" },
  "LBTAG100150BLUE": { name: "Label Tag Blue 100 x 150", category: "TAG" },
  "LBTAG100150GREEN": { name: "Label Tag Green 100 x 150", category: "TAG" },
  "LBTAG100150ORANGE": { name: "Label Tag Orange 100 x 150", category: "TAG" },
  "LBTAG100150RED": { name: "Label Tag Red 100 x 150", category: "TAG" },
  "LBTAG100150YELLOW": { name: "Label Tag Yellow 100 x 150", category: "TAG" },
  "SF01001": { name: "PVC Shrink Film 400 * 30 * 25u", category: "FILM" },
};

/**
 * The categories that count as resin, so that phr — parts per hundred
 * RESIN — has something to be per hundred of. Taken from the categories
 * actually present in the workbook rather than pattern-matched, so a new
 * category cannot silently start or stop counting as base polymer.
 */
export const RESIN_CATEGORIES: ReadonlySet<string> = new Set([
  "EVA RESIN",
  "HDPE RESIN",
  "LDPE RESIN",
  "LLDPE RESIN",
  "MDPE RESIN",
  "PP RESIN",
  "PVC RESIN",
]);
